import './App.css';

function App() {

  return (
    <div >
      <div class="heading">SOLAR SYSTEM</div>
        <div class="sun"></div>

        <div class="mercury"></div>
        <div class="venus"></div>
        <div class="earth">
          <div class="moon"></div>
        </div>
        <div class="mars"></div>
        <div class="jupiter"></div>
        <div class="saturn"></div>
        <div class="uranus"></div>
        <div class="neptune"></div>
    </div>
  );
}

export default App;

